"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    documentUploads: {
        path: "/files",
    },
    documentUploadDetail: {
        path: "/files/:id",
    },
    documentUploadFile: {
        path: "/view-file/:id",
    },
    geocodeDocument: {
        path: "/geocode-file/:id",
    },
    viewCertificateForReport: {
        path: "/certificates/:id",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZG9jdW1lbnRVcGxvYWRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vcm91dGluZy9kb2N1bWVudFVwbG9hZHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsbUNBQXNDO0FBRXpCLFFBQUEsTUFBTSxHQUFHLElBQUEsbUJBQVcsRUFBQztJQUNoQyxlQUFlLEVBQUU7UUFDZixJQUFJLEVBQUUsUUFBUTtLQUNmO0lBQ0Qsb0JBQW9CLEVBQUU7UUFDcEIsSUFBSSxFQUFFLFlBQVk7S0FDbkI7SUFDRCxrQkFBa0IsRUFBRTtRQUNsQixJQUFJLEVBQUUsZ0JBQWdCO0tBQ3ZCO0lBQ0QsZUFBZSxFQUFFO1FBQ2YsSUFBSSxFQUFFLG1CQUFtQjtLQUMxQjtJQUNELHdCQUF3QixFQUFFO1FBQ3hCLElBQUksRUFBRSxtQkFBbUI7S0FDMUI7Q0FDRixDQUFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBidWlsZFJvdXRlcyB9IGZyb20gXCIuL3R5cGVzXCI7XG5cbmV4cG9ydCBjb25zdCByb3V0ZXMgPSBidWlsZFJvdXRlcyh7XG4gIGRvY3VtZW50VXBsb2Fkczoge1xuICAgIHBhdGg6IFwiL2ZpbGVzXCIsXG4gIH0sXG4gIGRvY3VtZW50VXBsb2FkRGV0YWlsOiB7XG4gICAgcGF0aDogXCIvZmlsZXMvOmlkXCIsXG4gIH0sXG4gIGRvY3VtZW50VXBsb2FkRmlsZToge1xuICAgIHBhdGg6IFwiL3ZpZXctZmlsZS86aWRcIixcbiAgfSxcbiAgZ2VvY29kZURvY3VtZW50OiB7XG4gICAgcGF0aDogXCIvZ2VvY29kZS1maWxlLzppZFwiLFxuICB9LFxuICB2aWV3Q2VydGlmaWNhdGVGb3JSZXBvcnQ6IHtcbiAgICBwYXRoOiBcIi9jZXJ0aWZpY2F0ZXMvOmlkXCIsXG4gIH0sXG59KTtcbiJdfQ==